import React, { useContext, useState } from 'react';
import { Container, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import operationContext from '../../../context';
import esmrContext from '../context';
import { PageHeader, Section, SpinnerArea } from '../../../../../../shared/components';
import Context from '../../../../../App/MainProvider/context';
import useService from '../../../../../../shared/hooks/useService';
import toolkitService from '../../../../../../services/toolkitService';
import NotificationContext from '../../../../../Notifications/NotificationContext';
import { FlowCommentForm } from '../../../../../../services/types/Flow';
import CommentForm from '../../Comments/CommentForm';
import operEsmrCommentsService from '../../../../../../services/operEsmrCommentsService';

const EsmrCommentForm: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { service, notify } = useContext(Context);
  const [topics, loading] = useService(toolkitService.getTopics);
  const { operation } = useContext(operationContext);
  const { data: esmr } = useContext(esmrContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { reload: reloadNotifications } = useContext(NotificationContext);

  if (!esmr || !esmr.content) {
    return null;
  }

  const handleSubmit = (values: FlowCommentForm) => {
    service(
      () =>
        operEsmrCommentsService.create({
          ...values,
          keywords: values.keywords.map((x) => parseInt(x, 10)),
        }),
      {
        callback: () => {
          notify('ESMR Comments', t('successCreatedComment'), 'success');
          reloadNotifications();
          navigate(`/operations/${operation.number}/esmr/comments`);
        },
        loader: setIsSubmitting,
      }
    );
  };

  return (
    <SpinnerArea loading={loading}>
      {topics && (
        <Container className="dashboard">
          <PageHeader
            title={t('flowCommentFormTitle', { flowType: 'ESMR', number: operation.number })}
          />
          <Row>
            <Section title={t('flowCommentFormSectionTitle')} className="section-form">
              <hr />
              <CommentForm
                handleSubmit={handleSubmit}
                operationId={operation.id}
                isSubmitting={isSubmitting}
                topics={topics}
                topicTitle={t('topic')}
              />
            </Section>
          </Row>
        </Container>
      )}
    </SpinnerArea>
  );
};

export default EsmrCommentForm;
